import axios from "axios";

import { getToken } from "./tokens";

const axiosInstance = axios.create({
  baseURL: "https://melcarnedirectus2.digipulse.ch/",
});

axiosInstance.interceptors.request.use((config) => {
  const { token } = getToken();
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  config.headers["Content-Type"] = "application/json";

  if ((config.method ?? "get").toLowerCase() === "get") {
    config.params = { ...(config.params ?? {}), _ts: Date.now() };
  }

  return config;
});

axiosInstance.interceptors.response.use(
  (response) => response,
  (error) => {
    console.log(error);
    if (
      error.response &&
      error.response.status === 401 &&
      !error.request.responseURL.includes("auth/login")
    ) {
      localStorage.removeItem("x-token");
      window.location.href = "/login";
      return;
    }
    return Promise.reject(error);
  }
);

export default axiosInstance;
